<template>
  <div>
    <v-card elevation="1" class="mb-4 mt-2" v-if="invoice" @click="onClickHistory()">
      <v-list-item>
        <v-list-item-content class="py-0"><b>{{ $t('bill.bill_status') }}</b></v-list-item-content>
        <v-list-item-content class="py-0">
          <v-row
            justify="end"
            align="center"
            class="py-0 my-0 me-0"
          >
            <template v-if="!invoice.isCancelled">
              <v-chip
                v-if="invoice.isBadDebt"
                color="rgb(63, 63, 70)"
                text-color="white"
              >
                <span class="mx-5">{{ $t('bill.bad_debt') }}</span>
              </v-chip>
              <v-chip
                v-else-if="invoice.isPaid"
                color="green"
                text-color="white"
              >
                <span class="mx-5">{{ $t('payment.pay') }}</span>
              </v-chip>
              <v-chip
                v-else-if="invoice.isSent"
                color="blue"
                text-color="white"
              >
                <span class="mx-5">
                  <span v-if="invoice.isViewed">{{ $t('bill.renter_open_bill') }}</span>
                  <span v-else>{{ $t('bill.send_bill') }}</span>
                </span>
              </v-chip>
              <v-chip
                v-else-if="invoice.documentId"
                color="orange"
                text-color="white"
              >
                <span class="mx-5">{{ $t('bill.edit_bill') }}</span>
              </v-chip>
              <span v-else>{{ $t('no') }}</span>
            </template>
            <template v-else>
              <v-chip
                color="grey"
                text-color="white"
              >
                <span class="mx-5">{{ $t('bill.cancel') }}</span>
              </v-chip>
            </template>
          </v-row>
        </v-list-item-content>
      </v-list-item>
      <div class="text-center">
        <v-icon class="mx-1" small>
          mdi-clock-time-eight-outline
        </v-icon>
        <small class="text-decoration-underline">{{ $t('bill.view_bill_status_history') }}</small>
      </div>
    </v-card>

    <v-dialog
      v-model="isDialog"
      max-width="600"
      scrollable
    >
      <v-card v-if="!isLoading" class="pb-2" style="height: 100%;">
        <v-card-title
          class="d-flex justify-space-between align-center blue white--text py-2"
        >
          <span>{{ $t('bill.bill_status_history') }}</span>
          <span>
            <v-icon
              @click="isDialog = false"
              color="white"
            >
              mdi-close
            </v-icon>
          </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 500px;" class="px-0 py-0" v-if="logs && logs.length">
          <v-card v-for="log in logs" :key="log.objectId" class="my-2 mx-2" >
            <v-list-item class="py-2">
              <v-list-item-avatar 
                class="py-0 text-center" 
                tile
                min-width="250"
              >
                <v-row
                  justify="center"
                  align="center"
                  class="py-0 my-0"
                >
                  <v-chip
                    v-if="log.activity == 'paid'"
                    color="green"
                    text-color="white"
                  >
                    <span class="mx-5">{{ $t('payment.pay') }}</span>
                  </v-chip>
                  <v-chip
                    v-else-if="log.activity == 'sent'"
                    color="blue"
                    text-color="white"
                  >
                    <span class="mx-5">{{ $t('bill.send_bill') }}</span>
                  </v-chip>
                  <v-chip
                    v-else-if="log.activity == 'viewed'"
                    color="blue"
                    text-color="white"
                  >
                    <span class="mx-5">{{ $t('bill.renter_open_bill') }}</span>
                  </v-chip>
                  <v-chip
                    v-else-if="log.activity == 'unsent'"
                    color="orange"
                    text-color="white"
                  >
                    <span class="mx-5">{{ $t('bill.edit_bill') }}</span>
                  </v-chip>
                  <v-chip
                    v-else-if="log.activity == 'unpaid'"
                    color="red"
                    text-color="white"
                  >
                    <span class="mx-5">{{ $t('payment.cancel_pay_money') }}</span>
                  </v-chip>
                  <v-chip
                    v-else-if="log.activity == 'slip_verification_error'"
                    color="red"
                    text-color="white"
                  >
                    <span class="mx-5">{{ $t('validate.slip_verification_error') }}</span>
                  </v-chip>   
                  <v-chip
                    v-else-if="log.activity == 'cancelled'"
                    color="grey"
                    text-color="white"
                  >
                    <span class="mx-5">{{ $t('bill.cancel') }}</span>
                  </v-chip>
                  <v-chip
                    v-else-if="log.activity == 'bad_debt'"
                    color="rgb(63, 63, 70)"
                    text-color="white"
                  >
                    <span class="mx-5">{{ $t('bill.bad_debt') }}</span>
                  </v-chip>
                  <span v-else>{{ $t('no') }}</span>
                </v-row>
              </v-list-item-avatar>
              <v-list-item-content class="py-0">
                <span>
                  <p class="py-0 my-2"><b>{{ $t('date') }} : </b> {{ `${$moment(log.createdAt).format('DD/MM/YYYY')}` }} </p>
                  <p class="py-0 my-2"><b>{{ $t('time') }} : </b> {{ `${$moment(log.createdAt).format('LT')} ${$t('timeunit.minute.short')}` }} </p>
                  <p class="py-0 my-2"><b>{{ $t('by') }} : </b> 
                    <span v-if="log.user">{{ log.user.fullName }}</span>
                    <span v-else> - </span>
                  </p>
                </span>
              </v-list-item-content>
            </v-list-item>
            <v-card-text class="pt-0 pb-3" v-if="log.message">
              <v-card class="p-2" style="background-color: rgb(253, 248, 243);">
                {{ log.message }}
              </v-card>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-text v-else justify="center" align="center" class="py-5">
          <h3>{{ $t('no') }}</h3>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
      <v-card class="d-flex justify-space-between text-center py-10" elevation="1"  v-else>
        <center>
          <v-progress-circular
            indeterminate
            size="64"
            color="green"
          ></v-progress-circular>
        </center>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { InvoiceLog } from "../classes"
export default {
  props: {
    invoice: Object
  },
  data(){
    return {
      isDialog: false,
      logs: null,
      isLoading: false
    }
  },
  methods: {
    async onClickHistory(){
      this.isLoading = true
      this.isDialog = true
      try{
        this.logs = await InvoiceLog.getInvoiceLogs(this.invoice.objectId)
        this.isLoading = false
      }catch(error){ }      
    }
  }
}
</script>

<style>

</style>